import { render, staticRenderFns } from "./waterFallCulture.vue?vue&type=template&id=49f05e00&"
import script from "./waterFallCulture.vue?vue&type=script&lang=js&"
export * from "./waterFallCulture.vue?vue&type=script&lang=js&"
import style0 from "./waterFallCulture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports